import { render, staticRenderFns } from "./ResourceHeader.vue?vue&type=template&id=08d52d27"
import script from "./ResourceHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResourceHeader.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports